export default __webpack_public_path__ + "4347867ad5d480d9323212be45dac334.jpg";